import MessageBox from './src/main.js';
export default MessageBox;



// WEBPACK FOOTER //
// ./src/components/element/packages/message-box/index.js